module.exports = __webpack_public_path__ + "img/bb_g3_t_mouth-03.d91f6cbb.svg";